import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Webservice from "../../assets/pic/api.png"


const WebServiseEn = ()=>{
    return(
        <div className="webservice-wrap">
            <Nav/>
            <div className="webservice-dec">
                <h1>Web Service Documents</h1>
                <img src={Webservice} alt=""/>
                <p>
                    To use all the features of BellMeet system in your application, you can use BellMeet web service. The web service is in REST format, all request are in POST format and the inputs are in JSON format which will be explained below.
                </p>
                <br/>
                <p>Also note that all requests will be returned in 200 HTTP status code.</p>
                <p>The address of all requests will be as follows:</p>
                <pre>
                    <code>
                        https://online.bellmeet.com/api/apiToken
                    </code>
                </pre>
                <p>Which the service key will be provided to you after receiving the account.</p>
                <h2>Sending request example:</h2>
                <p>In general, the POST request with JSON data is as follows:</p>
                <p>Note that:</p>
                <ul>
                    <li>·	Uppercase and lowercase letters are different in all parts.</li>
                    <li>·	The value of "method" is always String and is the name of the request - for example getUsers which is for receiving users.</li>
                    <li>·	In the "params" section, each "PARAM_*" is a parameter name, and the value of each can be String, Array and Object based on the request type.</li>
                </ul>
                <pre>
                    <code>
                        POST https://online.bellmeet.com/api/603e29064544163adsa08bbd2e/b5746e8-fa7a-843-957c-asda465qwed769a
                        {`
 {
    "method": "METHOD_FOR_DO",
    "params": {
                "PARAM_1": "SOME_DATA_1",
                "PARAM_2": "SOME_DATA_2",
                ...
              }
 }
  `}
                    </code>
                </pre>
                <p>The response to all the functions used includes the phrase "success", which is Boolean and specifies the result of the request.</p>
                <p>Also, if "success" is false, there will be "error" and "code" fields that specify the cause of the error, which will be explained below.</p>
                <p>You can also use "page" and "per_page" filters as query params to limit the page and the number of items per page.</p>
                <h3>List of role IDs:</h3>
                <div className="table-mamad">
                    <table className="ltr table-right" >
                        <thead>
                        <tr>
                            <td>
                                <p><strong>ID</strong></p>
                            </td>
                            <td>
                                <p><strong>Name</strong></p>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <p>4</p>
                            </td>
                            <td>
                                <p>Admin</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>3</p>
                            </td>
                            <td>
                                <p>Host</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>2</p>
                            </td>
                            <td>
                                <p>Provider</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>1</p>
                            </td>
                            <td>
                                <p>User</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <p>Sample process for creating and using a webinar:</p>
                <ul>
                    <li>1.	Create a room</li>
                    <li>2.	Create user(s)</li>
                    <li>3.	Give users access to use the created room</li>
                    <li>4.	Get the link to enter the room</li>
                </ul>
                <br/>
                <h2>List of usable functions:</h2>
                <br/>
                <h3>1- Receive service information:</h3>
                <pre>
                    <code>
                        getService
                    </code>
                </pre>
                <p>With this function, your current service will be shown.</p>
                <pre>
                    <code>
                        {`{
     "method":"getService",
     "params":{}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <pre>
                    <code>
 {`{
     "success": true,
     "service": {
                    "id": 1,
                    "name": "Free Plan",
                    "display_name": "Test",
                    "max_user": 1000,
                    "active": true,
                    "expire_date": 9782946000,
                    "video_limit": 5,
                    "createdAt": "2021-03-02T12:01:15.747Z",
                    "updatedAt": "2021-06-10T08:18:33.673Z"
                }
 }`}
                    </code>
                </pre>
                <p>Response Description: </p>
                <table className="ltr table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Service Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>display_name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Display name in room</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Capacity of service users</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>video_limit</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>concurent camera limit</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>expire_date</p>
                        </td>
                        <td>
                            <p>Unix time</p>
                        </td>
                        <td>
                            <p>expiration date</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h2>2- Get information of all users:</h2>
                <pre>
                    <code>
                        getUsers
                    </code>
                </pre>
                <p>With this function, your service users will be shown.</p>
                <pre>
                    <code>
 {`{
        "method":"getUsers",
        "params":{}
  }`}
                    </code>
                </pre>
                <p>Response: </p>
                <pre>
                    <code>
  {`{
    "success": true,
    "users": {
                "docs": [
                            {
                                "id": 34,
                                "username": "testimport6",
                                "name": "test6",
                                "active": true,
                                "createdAt": "2021-06-09T11:10:48.415Z",
                                "updatedAt": "2021-06-09T11:10:48.415Z",
                                "service_name": "Free Plan",
                                "service_id": 1
                            },
                            {
                                "id": 33,
                                "username": "testimport5",
                                "name": "test5",
                                "active": true,
                                "createdAt": "2021-06-09T11:10:48.076Z",
                                "updatedAt": "2021-06-09T11:10:48.076Z",
                                "service_name": " Free Plan ",
                                "service_id": 1
                            }
                        ],
    "totalDocs": 16,
    "limit": 10,
    "totalPages": 2,
    "page": 1,
    "pagingCounter": 1,
    "hasPrevPage": false,
    "hasNextPage": true,
    "prevPage": null,
    "nextPage": 2
            }
}`}
                    </code>
                </pre>
                <p>Response Description: </p>
                <table className="ltr table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Username</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_name</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>3- Receive user information:</h2>
                <pre>
                    <code>
                        getUser
                    </code>
                </pre>
                <p>
                    With thnis function, a user of your service will be shown.
                    <br/>
                    In this function, you can use one of the optional parameters to get the desirec user.
                    <br/>
                    The "id" parameter is to search by ID and "username" by username. (One of the two must be sent)
                </p>
                <pre>
                    <code>
{`{
\t"method":"getUser",
\t"params":{
\t\t"id" : "ID",
\t\t"username" : "USERNAME"
\t}
 }`}
                    </code>
                </pre>
                <p>
                    Response:
                </p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Username</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>
                    Response Description: 
                </p>
                <pre>
                    <code>
{`{
    "success": true,
    "user": {
            "id": 6,
            "username": "bj_5",
            "name": "New user",
            "active": true,
            "createdAt": "2021-03-09T10:17:34.703Z",
            "updatedAt": "2021-03-09T10:17:34.703Z",
            "service_name": " Free Plan ",
            "service_id": 1
            }
 }`}
                    </code>
                </pre>
                <p>
                    Result Description:
                </p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Username</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_name</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>4- Create user:</h2>
                <pre>
                    <code>createUser</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"createUser",
\t"params":{
\t\t"username":"USERNAEM",
\t\t"password":"PASSWORD",
\t\t"name":"NAME"
\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Username</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>password</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>User password</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>User name</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "user": {
            "id": 6,
            "username": "bj_5",
            "name": "New user",
            "active": true,
            "createdAt": "2021-03-09T10:17:34.703Z",
            "updatedAt": "2021-03-09T10:17:34.703Z",
            "service_name": " Free Plan ",
            "service_id": 1
            }
 }
`}
                    </code>
                </pre>
                <p>Result Description:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Username</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_name</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>5- Edit user:</h2>
                <pre>
                    <code>editUser</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"editUser",
\t"params":{
\t\t"id":"ID",
\t\t"username":"USERNAEM",
\t\t"password":"PASSWORD",
\t\t"name":"NAME"
\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td >
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>number</p>
                        </td>
                        <td>
                            <p>User id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Username</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>previous_data</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>password</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>User password</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>previous_data</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>User name</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>previous_data</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "user": {
            "id": 6,
            "username": "bj_5",
            "name": "Edited user",
            "active": true,
            "createdAt": "2021-03-09T10:17:34.703Z",
            "updatedAt": "2021-03-09T10:17:34.703Z",
            "service_name": " Free Plan ",
            "service_id": 1
            }
 }`}
                    </code>
                </pre>
                <p>Result Description:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>username</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Username</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_name</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>service_id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Service id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h2>6- Delete user:</h2>
                <pre>
                    <code>deleteUser</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"deleteUser",
\t"params":{
                             "id":"ID"
\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>number</p>
                        </td>
                        <td>
                            <p>User id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <br/>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
 }`}
                    </code>
                </pre>
                <h2>7- Get information of all rooms:</h2>
                <pre>
                    <code>getRooms</code>
                </pre>
                <p>With this function, your service rooms will be shown.</p>
                <pre>
                    <code>
{`{
\t"method":"getRooms",
\t"params":{}
 }`}
                    </code>
                </pre>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "rooms": {
             "docs":[
                     {
                        "id": 18,
                        "name": "101042",
                        "slug": "my-link2",
                        "duration": 0,
                        "max_user": 10,
                        "has_guest": true,
                        "link": "c2c4165e-c0b4-4e40-be23-eabdaaef9844",
                        "active": true,
                        "host_start": false,
                        "redirect_url": "",
                        "createdAt": "2021-06-08T10:44:01.035Z",
                        "updatedAt": "2021-06-10T07:08:24.762Z",
                        "service_name": "Free Plan",
                        "service_id": 1
                     }
                    ],
            "totalDocs": 16,
            "limit": 10,
            "totalPages": 2,
            "page": 1,
            "pagingCounter": 1,
            "hasPrevPage": false,
            "hasNextPage": true,
            "prevPage": null,
            "nextPage": 2
            }
 }`}
                    </code>
                </pre>
                <p>Result Description:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Dedicated address</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room time (seconds)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Maximum number of users</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_geust</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Has guests</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Room link</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Started by Host</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Redirect link after exit</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>8- Get information about a room:</h2>
                <pre>
                    <code>getRoom</code>
                </pre>
                <p>With this function, the desired service room will be shown.</p>
                <pre>
                    <code>
{`{
\t"method":"getRoom",
\t"params":{
\t\t"id" : "ID"
\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "room": 
             {
                "id": 18,
                "name": "101042",
                "slug": "my-link2",
                "duration": 0,
                "max_user": 10,
                "has_guest": true,
                "link": "c2c4165e-c0b4-4e40-be23-eabdaaef9844",
                "active": true,
                "host_start": false,
                "redirect_url": "",
                "createdAt": "2021-06-08T10:44:01.035Z",
                "updatedAt": "2021-06-10T07:08:24.762Z",
                "service_name": "Free Plan",
                "service_id": 1
            }
 }`}
                    </code>
                </pre>
                <p>Result Description:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Dedicated address</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room time (seconds)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Maximum number of users</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_geust</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Has guests</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Room link</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Started by Host</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Redirect link after exit</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>9- Create room:</h2>
                <pre>
                    <code>createRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"createRoom",
\t"params":{
\t\t"name":"USERNAEM",
\t\t"duration":"PASSWORD",
\t\t"max_user":"NAME",
\t\t…Optional_Fileds
\t\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Room name</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room time (seconds)</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Maximum user capacity</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_guest</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Has guests</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>false</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Start with the Host</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>false</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Redirect link after exit</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>null</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Dedicated address</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>null</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "room": 
             {
                "id": 18,
                "name": "101042",
                "slug": "my-link2",
                "duration": 0,
                "max_user": 10,
                "has_guest": true,
                "link": "c2c4165e-c0b4-4e40-be23-eabdaaef9844",
                "active": true,
                "host_start": false,
                "redirect_url": "",
                "createdAt": "2021-06-08T10:44:01.035Z",
                "updatedAt": "2021-06-10T07:08:24.762Z",
                "service_name": "Free Plan",
                "service_id": 1
             }
 }`}
                    </code>
                </pre>
                <p>Result Description:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Dedicated address</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room time (seconds)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Maximum number of users</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_geust</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Has guests</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Room link</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Started by Host</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Redirect link after exit</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>10- Edit room:</h2>
                <pre>
                    <code>editRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"editRoom",
\t"params":{
\t\t"id":"ID",
\t\t"name":"NAME",
\t\t…Other_Fileds
\t\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Room name</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room time (seconds)</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Maximum user capacity</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_guest</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Has guests</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>false</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Start with the Host</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>false</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Redirect link after exit</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>null</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Dedicated address</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>null</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "room": 
             {
                "id": 18,
                "name": "101042-Edited",
                "slug": "my-link2",
                "duration": 0,
                "max_user": 10,
                "has_guest": true,
                "link": "c2c4165e-c0b4-4e40-be23-eabdaaef9844",
                "active": true,
                "host_start": false,
                "redirect_url": "",
                "createdAt": "2021-06-08T10:44:01.035Z",
                "updatedAt": "2021-06-10T07:08:24.762Z",
                "service_name": "Free Plan",
                "service_id": 1
             }
 }`}
                    </code>
                </pre>
                <p>Result Description:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>slug</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Dedicated address</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>duration</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room time (seconds)</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>max_user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Maximum number of users</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>has_geust</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Has guests</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Room link</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>host_start</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Started by Host</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>redirect_url</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Redirect link after exit</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>active</p>
                        </td>
                        <td>
                            <p>Boolean</p>
                        </td>
                        <td>
                            <p>Activity status</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>createdAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Creation time</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>updatedAt</p>
                        </td>
                        <td>
                            <p>Date</p>
                        </td>
                        <td>
                            <p>Update time</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h2>11- Delete room</h2>
                <pre>
                    <code>deleteRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"deleteRoom",
\t"params":{
\t\t"id":"ID"
\t\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <br/>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
 }`}
                    </code>
                </pre>
                <h2>Access functions:</h2>
                <br/>
                <h2>1- Add user(s) access to the room:</h2>
                <pre>
                    <code>addUsersToRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"addUsersToRoom",
\t"params":{
\t\t  "id":"ID",
\t\t  "users":[
\t\t\t  {
\t\t\t  "user":"USER_ID",
\t\t\t  "role":"ROLE_ID"
\t\t\t  },
\t\t\t  {
\t\t\t  "user":"USER_ID2",
\t\t\t  "role":"ROLE_ID2"
\t\t\t  },
\t\t\t  …
\t\t\t  ],
\t\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>users[]</p>
                        </td>
                        <td>
                            <p>Array[object]</p>
                        </td>
                        <td>
                            <p>Users have access</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>users[].user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>User id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>users[].role</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Rool id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true
 }`}
                    </code>
                </pre>
                <h2>2- Remove user(s) access to the room:</h2>
                <pre>
                    <code>removeUsersFromRoom</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"removeUsersFromRoom",
\t"params":{
\t\t"id":"ID",
\t\t"users":[
\t\t\tUSER_ID1,
\t\t\tUSER_ID2,
\t\t\t…
\t\t\t],
\t\t}
}`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>users[]</p>
                        </td>
                        <td>
                            <p>Array[Number]</p>
                        </td>
                        <td>
                            <p>Users to remove access</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>users[item]</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>User id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true
 }`}
                    </code>
                </pre>
                <h2>3- Get a user's rooms:</h2>
                <pre>
                    <code>getUserRooms</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"getUserRooms",
\t"params":{
\t\t"id":"USER_ID"
\t\t }
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>User id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "rooms": [
            {
            "room_name": "new class",
            "id": 4,
            "role": "admin"
            },
            {
            "room_name": "101042",
            "id": 18,
            "role": "operator"
            },
            …
            ]
 }`}
                    </code>
                </pre>
                <p>Result Description:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>rooms[]</p>
                        </td>
                        <td>
                            <p>Array[object]</p>
                        </td>
                        <td>
                            <p>List of user rooms</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>rooms[].room_name</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Room name</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>rooms[].id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room id</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>rooms[].role</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>User role name</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <h2>4- Get a list of a room users:</h2>
                <pre>
                    <code>getRoomUsers</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"getRoomUsers",
\t"params":{
\t\t"id":"ROOM_ID"
\t\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>id</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "users": {
            "docs": [
                    {
                    "id": 5,
                    "username": "bj_4",
                    "name": "User",
                    "active": true,
                    "createdAt": "2021-03-06T21:00:09.267Z",
                    "updatedAt": "2021-06-15T06:21:15.586Z",
                    "service_name": "Free Plan",
                    "service_id": 1,
                    "role": {
                            "name": "operator",
                            "id": 3
                            }
                    }
                    ],
            "totalDocs": 1,
            "limit": 10,
            "totalPages": 1,
            "page": 1,
            "pagingCounter": 1,
            "hasPrevPage": false,
            "hasNextPage": false,
            "prevPage": null,
            "nextPage": null
            } 
 }`}
                    </code>
                </pre>
                <h2>5- Get link to enter the room:</h2>
                <p>After adding user access, you can now get the direct user login link through this function.</p>
                <pre>
                    <code>getLink</code>
                </pre>
                <pre>
                    <code>
{`{
\t"method":"getLink",
\t"params":{
\t\t"room":"ROOM_ID",
\t\t"user":"USER_ID",
\t\t"ttl":"TIME_TO_LIVE",
\t\t}
 }`}
                    </code>
                </pre>
                <p>Response:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                        <td>
                            <p><strong>Require</strong></p>
                        </td>
                        <td>
                            <p><strong>Default</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>room</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Room id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>user</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>User id</p>
                        </td>
                        <td>
                            <p>Yes</p>
                        </td>
                        <td>
                            <p>-</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>ttl</p>
                        </td>
                        <td>
                            <p>Number</p>
                        </td>
                        <td>
                            <p>Link validity (seconds)</p>
                        </td>
                        <td>
                            <p>No</p>
                        </td>
                        <td>
                            <p>3600</p>
                        </td>
                    </tr>
                    </thead>
                </table>
                <p>Response Description: </p>
                <pre>
                    <code>
{`{
    "success": true,
    "link": "https://online.bellmeet.com/r/18/5-4aeb8c10-cda9-11eb-adf1-29d6896ec3c7-OiQlZt3CZZ6tI4VgpoIpHbfh87YhsTMzi33CwvQR9Q0RRFQOhvMDv3QWN6eBsrQw" 
 }`}
                    </code>
                </pre>
                <p>Result Description:</p>
                <table className="table-right">
                    <thead>
                    <tr>
                        <td>
                            <p><strong>Filed</strong></p>
                        </td>
                        <td>
                            <p><strong>Type</strong></p>
                        </td>
                        <td>
                            <p><strong>Name</strong></p>
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <p>link</p>
                        </td>
                        <td>
                            <p>String</p>
                        </td>
                        <td>
                            <p>Direct login link</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <Footer/>
        </div>
    )
}

export default WebServiseEn